import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Avatar} from 'views/components';
import {useNavigate} from 'views/module';

const ClientRow = (props) => {
  const navigate = useNavigate();

  const {user} = props;
  const userPath = props.userPath || '/client';

  const handleClick = (e) => {
    const url = `${userPath}/${user.clientRn}`;
    if (e.ctrlKey || e.metaKey) {
      // Open in a new tab
      window.open(url, '_blank');
    } else {
      // Regular navigation
      navigate(url);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      px={1.5}
      py={1}
      onClick={handleClick}
      sx={{cursor: 'pointer'}}
    >
      <Avatar
        alt={user.clientName}
        src={user.profileImg}
      />
      <Typography fontWeight={600} variant="subtitle1">{user.clientName}</Typography>
    </Stack>
  );
};

ClientRow.propTypes = {
  user: PropTypes.shape({
    clientRn: PropTypes.string.isRequired,
    clientName: PropTypes.string.isRequired,
    profileImg: PropTypes.string,
  }).isRequired,
  userPath: PropTypes.string,
};

export default ClientRow;
